import classNames from "classnames"
import React from "react"

import { Color } from "../../../constants/V2/color"
import Accordion from "../../elements/V2/Accordion"

import { getBorderColorClass } from "@utils/V2/color"

type Props = {
  question: string
  answerText: Storyblok.StoryblokRichtextContent
  linkColor: Color
  textColor: Color
}

const FaqItem = ({ question, answerText, linkColor, textColor }: Props) => (
  <div>
    <Accordion
      title={question}
      iconColor={linkColor}
      textColor={textColor}
      body={answerText}
    />
    <hr
      className={classNames("mt-16 opacity-30", getBorderColorClass(textColor))}
    />
  </div>
)

export default FaqItem
